import { PageGrid } from '../PageGrid';
import { GridItem } from '../GridItem';
import { Stack } from '../Stack';
import { Box } from '../Box';
import { useAdsContext } from '../../providers';
import * as styles from './TextWithSideImage.css';

type TextWithSideImageProps = {
  title?: React.ReactElement;
  text?: React.ReactElement;
  image?: React.ReactElement;
  isContained?: boolean;
} & styles.TextWithSideImageVariants;

export const TextWithSideImage = ({
  title,
  text,
  image,
  alignment = 'right',
  isContained = false,
}: TextWithSideImageProps) => {
  return isContained ? (
    <TextWithSideImageContent
      title={title}
      text={text}
      image={image}
      alignment={alignment}
      isContained
    />
  ) : (
    <PageGrid>
      <GridItem
        columnStart={isContained ? '1' : { initial: '1', md: '3' }}
        columnEnd={isContained ? '-1' : { initial: '-1', md: '-3' }}
      >
        <TextWithSideImageContent
          title={title}
          text={text}
          image={image}
          alignment={alignment}
          isContained
        />
      </GridItem>
    </PageGrid>
  );
};

const TextWithSideImageContent = ({
  title,
  text,
  image,
  alignment = 'right',
}: TextWithSideImageProps) => {
  const context = useAdsContext();
  const classNames = styles.textWithSideImage({ alignment });
  const topOffset = context.topHeaderHeight ? context.topHeaderHeight + 16 : 0;

  return (
    <Box className={classNames}>
      {title ? <Box className={styles.title}>{title}</Box> : null}
      {image ? (
        <Box className={styles.image} position="relative" asChild>
          <Stack isFullWidth isFullHeight>
            <Box position="sticky" width="100%" top={`${topOffset}px`} asChild>
              {image}
            </Box>
          </Stack>
        </Box>
      ) : null}

      {title || text ? (
        <Box className={styles.text}>
          <Box width="100%">{text}</Box>
        </Box>
      ) : null}
    </Box>
  );
};

